module.exports = __webpack_public_path__ + "456146441d34344f1f4742484776208e.png";